import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { hiringCompanySettingsTabs } from "./companyDetails.const";

const CompanyDetails: React.FC = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const activeTab = pathname;

  return (
    <div className="flex flex-1 flex-col md:flex-row mt-6 gap-6 h-full overflow-hidden">
      {/* Sidebar */}
      <div className="w-full md:w-64 shrink-0 border-r pr-1">
        <div className="rounded-md text-xs space-y-2">
          {hiringCompanySettingsTabs?.map((x) => (
            <div
              onClick={() => navigate(x.path)}
              className={`px-4 py-3 cursor-pointer rounded-md ${
                activeTab === x.path
                  ? "bg-gray-100 font-medium"
                  : "text-gray-700 hover:bg-gray-50"
              }`}
            >
              {x.name}
            </div>
          ))}
        </div>
      </div>
      <div className="flex-1 flex w-[100%] overflow-y-scroll no-scrollbar">
        <Outlet />
      </div>
    </div>
  );
};

export default CompanyDetails;
